import {
  getPageInfo,
  getIndividualPageData,
} from '@/api/global';

import SlickComponentLibs from '@/components/CarouselComponentSlickStyles';
import {default as GolfHoleTemplate} from '@/components/04_templates/CoursePage/CoursePage';
// import Spinner from '@/components/01_atoms/Spinner';

export async function getStaticProps(context) {
  const {params} = context;
  let initialProps = {
    statusCode: 200,
  };

  let data = null;

  try {
    data = await getPageInfo(`/golf/courses/${params.course}/holes/${params.hole}/${params.hole_name}`);

    if (data && data.page && data.page.entity) {
      let node_data = null;
      node_data = await getIndividualPageData(data.page.jsonapi.individual);
      if (node_data) {
        initialProps = {...initialProps, ...node_data};
      }
    }
    if (!data) {
      return {
        notFound: true,
      }
    }
  }
  catch (e) {
    console.warn('GOLF HOLE retrieval error:', e);
    // Pass status code as internal properly. It is being checked inside of
    // render() method of _app.js.
    initialProps.statusCode = 500;

    // In case of Server Side Rendering, we want the server to throw the
    // correct error code.
    // if (res) {
    //   res.statusCode = 500;
    // }
  }

  return {
    props: {
      ...initialProps,
    },
    revalidate: 10800,
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  }
}

export async function getStaticPaths() {
  let paths = [
    { params: { course: 'woodside', hole: '1', hole_name: 'woodside-1st-green' } },
    { params: { course: 'woodside', hole: '2', hole_name: 'woodside-2nd-green' } },
    { params: { course: 'woodside', hole: '3', hole_name: 'woodside-3rd-green' } },
    { params: { course: 'waterside', hole: '10', hole_name: 'waterside-10th-green' } },
    { params: { course: 'waterside', hole: '11', hole_name: 'waterside-11th-green' } },
    { params: { course: 'waterside', hole: '12', hole_name: 'waterside-12th-green' } },
  ];
  return {paths, fallback: true}
}

function GolfHolePage(props) {
  const node = props.page?.entity || null;
  let node_data = null;

  if (node && props.page_data) {
    node_data = props.page_data;
  }
  return (
    <>
      {(node_data && node.bundle == 'golf') &&
        <>
          <SlickComponentLibs/>
          <GolfHoleTemplate node={node_data}/>
        </>
      }
    </>
  );
}

export default GolfHolePage;
